import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Grid,
  TextField,
  Card,
  CardContent,
  InputAdornment,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

/**
 * Component for managing hourly prices based on guest count range
 */
const HourlyPricesByGuests = ({ prices, updatePrice, removePrice, addPrice }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        Цены по количеству гостей
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Укажите разные цены за час в зависимости от диапазона количества гостей
      </Typography>

      {prices.map((price, index) => (
        <Card key={index} variant="outlined" sx={{ mb: 2 }}>
          <CardContent sx={{ pb: 1 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={3}>
                <TextField
                  label="От (гостей)"
                  type="number"
                  fullWidth
                  value={price.minGuests || price.guests || 1}
                  onChange={(e) => updatePrice(index, {
                    ...price,
                    minGuests: parseInt(e.target.value, 10) || 1
                  })}
                  inputProps={{ min: 1 }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="До (гостей)"
                  type="number"
                  fullWidth
                  value={price.maxGuests || price.guests || 1}
                  onChange={(e) => updatePrice(index, {
                    ...price,
                    maxGuests: parseInt(e.target.value, 10) || 1
                  })}
                  inputProps={{ min: 1 }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Цена за час"
                  type="number"
                  fullWidth
                  value={price.price}
                  onChange={(e) => updatePrice(index, {
                    ...price,
                    price: parseInt(e.target.value, 10) || 0
                  })}
                  inputProps={{ min: 0, step: 100 }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">₽</InputAdornment>,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <IconButton 
                  color="error" 
                  onClick={() => removePrice(index)}
                  aria-label="Удалить"
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ))}

      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={() => addPrice({ minGuests: 1, maxGuests: 6, price: 0 })}
        sx={{ mt: 1 }}
      >
        Добавить ценовую категорию
      </Button>
    </Box>
  );
};

HourlyPricesByGuests.propTypes = {
  prices: PropTypes.arrayOf(
    PropTypes.shape({
      minGuests: PropTypes.number,
      maxGuests: PropTypes.number,
      price: PropTypes.number.isRequired
    })
  ).isRequired,
  updatePrice: PropTypes.func.isRequired,
  removePrice: PropTypes.func.isRequired,
  addPrice: PropTypes.func.isRequired
};

export default HourlyPricesByGuests;
